import type { ReplaceExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const replaceResolver =
  createSimpleNamedExpressionResolver<ReplaceExpression>(
    'replace',
    (value, regex, replaceValue) =>
      value.replace(new RegExp(regex), replaceValue)
  );
